module.exports = __webpack_public_path__ + "img/sixpackcarrier60.ffc8dd10.jpg";